import { render, staticRenderFns } from "./SubmissionLogsTable.vue?vue&type=template&id=73196d70&"
import script from "./SubmissionLogsTable.vue?vue&type=script&lang=js&"
export * from "./SubmissionLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionLogsTable.vue?vue&type=style&index=0&id=73196d70&prod&lang=scss&module=true&"
import style1 from "./SubmissionLogsTable.vue?vue&type=style&index=1&id=73196d70&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports